import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../shared/api/axios-instance';
import { createPathParams } from '../../shared/utils/create-path-params/create-path-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';

export const getAppReleasesTotalCount: AsyncThunk<
  number,
  number,
  Record<number, unknown>
> = createAsyncThunk('app/releases/total-count', async (appId: number) => {
  const pathParams = createPathParams<'appId'>(
    Endpoints.APP_RELEASES_TOTAL_COUNT,
    {
      appId,
    }
  );

  const { data }: AxiosResponse<number> = await axiosInstance.get(pathParams);

  return data;
});
